import { render, staticRenderFns } from "./LagerverteilungView.vue?vue&type=template&id=c3215d32&"
import script from "./LagerverteilungView.vue?vue&type=script&lang=js&"
export * from "./LagerverteilungView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports